import type { EmsComponents } from '@ngsos/portal-core/api/ems';

import { emsApi } from '@/api/emsApi';


export type ElsRecord = EmsComponents['schemas']['NG_SOS.Els.Domain.ElsRecord'];
export type ElsEmergencyContact = EmsComponents['schemas']['NG_SOS.Els.Domain.ElsEmergencyContact'];
export type ElsLocation = EmsComponents['schemas']['NG_SOS.Els.Domain.ElsLocation'];
export type ElsEmergencyInfo = EmsComponents['schemas']['NG_SOS.Els.Domain.ElsEmergencyInfo'];
export type ElsMedicalInfo = EmsComponents['schemas']['NG_SOS.Els.Domain.ElsMedicalInfo'];

export function elsRecordQueryKey(incidentId: string, phoneNumbers: readonly string[]): readonly unknown[] {
  return ['incident', incidentId, 'els-record', ...phoneNumbers];
}

export async function fetchLatestElsData(phoneNumbers: readonly string[]): Promise<ElsRecord | null> {
  for (const phoneNumber of phoneNumbers) {
    try {
      const { data } = await emsApi.POST('/els/v1/latest-data', { body: { phoneNumber } });
      if (data != null) {
        return data;
      }
    } catch (error) {
      console.log(`[IncidentDetail] ELS lookup failed for ${phoneNumber}: ${String(error)}`);
    }
  }

  return null;
}
